import React, { useEffect, useState } from "react"
import { useParams } from "react-router"
import { useToasts } from "react-toast-notifications"
import { useCart } from "react-use-cart"
import CustomerRegistryItems from "../../components/CustomerRegistryComponents/CustomerRegistryItems"
import CustomerRegistryViewHero from "../../components/CustomerRegistryComponents/CustomerRegistryViewHero"
import FullLoader from "../../components/Loaders/FullLoader"
import ErrorPopup from "../../components/ModalContainer/Popups/ErrorPopup"
import Navbar from "../../components/Navbar/Navbar"
import { useEvent } from "../../context/EventContext"
import { getRegistryBySlug } from "../../utils/ApiRequests"
import { getApiErrorMessage } from "../../utils/ApiUtils"
import "./styles.scss"

const CustomerRegistryPage = () => {
  const { slug } = useParams()
  const [loading, setLoading] = useState(true)
  const [registry, setRegistry] = useState({})
  const { addToast } = useToasts()
  const { setCurrentRegistry } = useEvent()
  const { isEmpty, emptyCart } = useCart()
  const [checkCart, setCheckCart] = useState(isEmpty)

  useEffect(() => {
    getRegistryBySlug(slug)
      .then(res => {
        setRegistry(res.data.data)
        setLoading(false)
        setCurrentRegistry(res.data.data?._id)
      })
      .catch(err => {
        addToast(getApiErrorMessage(err.response), {
          appearance: "error",
          autoDismiss: true
        })
        setLoading(false)
      })
  }, [slug, addToast, setCurrentRegistry])

  const {
    name,
    products,
    header_image,
    categories,
    minProductPrice,
    maxProductPrice,
    subheader_images,
    contributions
  } = registry

  return (
    <>
      <Navbar />
      {loading && <FullLoader />}
      {!loading && !checkCart && (
        <ErrorPopup
          content="Would you like to clear existing items in cart?"
          handleClose={() => setCheckCart(true)}
          handleSuccess={() => {
            emptyCart()
            setCheckCart(true)
          }}
        />
      )}
      {!loading && (
        <>
          <CustomerRegistryViewHero
            name={name}
            header_image={header_image}
            subheader_images={subheader_images}
          />
          <CustomerRegistryItems
            products={products}
            categories={categories}
            minProductPrice={minProductPrice}
            maxProductPrice={maxProductPrice}
            contributions={contributions}
          />
        </>
      )}
    </>
  )
}

export default CustomerRegistryPage
